import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/da20tplv7gurs51ef2t0';

type Status = 'idle' | 'submitting' | 'success' | 'error';

const principles = [
  { icon: 'ri-translate-2', title: '独家汉化', desc: '独立完成的汉化版本，翻译自然流畅' },
  { icon: 'ri-flashlight-fill', title: '抢先一步', desc: '领先全网上新，第一时间读到新章' },
  { icon: 'ri-file-4-fill', title: '未删减原版', desc: '高清原图，完整分镜对白不阉割' },
  { icon: 'ri-refresh-fill', title: '同步更新', desc: '与热门作品保持同步，追更不落后' },
];

export default function AboutContact() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honey = (fd.get('company_alt') || '').toString().trim();

    setStatus('submitting');
    setFormError('');

    if (honey) {
      setStatus('success');
      form.reset();
      return;
    }

    const body = new URLSearchParams();
    const name = (fd.get('name') || '').toString().trim();
    const email = (fd.get('email') || '').toString().trim();
    const subject = (fd.get('subject') || '').toString().trim();
    const message = (fd.get('message') || '').toString().trim();
    if (name) body.append('name', name);
    if (email) body.append('email', email);
    if (subject) body.append('subject', subject);
    if (message) body.append('message', message);

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const serverMsg = String(msg || '');
      const ok = res.ok && parsed && parsed.code === 'OK' && !/spam/i.test(serverMsg);

      if (!ok) {
        setStatus('error');
        setFormError(serverMsg && serverMsg !== '' ? serverMsg : '提交失败，请稍后再试');
        return;
      }
      setStatus('success');
      form.reset();
    } catch (err) {
      setStatus('error');
      setFormError('网络异常，请稍后再试');
    }
  };

  return (
    <section id="about" className="mx-auto w-full max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div>
          <p className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-cup-line text-primary-500"></i>
            关于我们
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            让每一个追更的人，都能抢先看到原汁原味的漫画
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            喵趣漫画网是一个专注汉化连载的漫画阅读平台。我们相信，好的作品不该被拖延，更不该被阉割。因此我们坚持独家汉化、抢先上线、未删减高清原版，与热门作品同步更新，让每一位读者都能第一时间读到最新剧情。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            从热血战斗到甜甜恋爱，从悬疑烧脑到轻松爆笑，我们覆盖全题材，只为找到那部最懂你的连载。你的追更，交给我们守候。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{p.title}</p>
                  <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-7">
          <h3 className="font-heading text-xl text-primary-600">订阅追更 &amp; 联系我们</h3>
          <p className="mt-2 text-sm text-foreground-600">
            留下你的邮箱订阅追更提醒，或填写意见反馈，我们会在 1 个工作日内回复。
          </p>

          <form
            data-readdy-form="漫画订阅与联系反馈"
            className="mt-5 flex flex-col gap-4"
            onSubmit={handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label htmlFor="name" className="mb-1.5 block text-xs font-semibold text-foreground-800">
                  称呼（选填）
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  autoComplete="name"
                  placeholder="你的昵称"
                  className="h-11 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
              </div>
              <div>
                <label htmlFor="email" className="mb-1.5 block text-xs font-semibold text-foreground-800">
                  邮箱
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  className="h-11 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
              </div>
            </div>

            <div>
              <label htmlFor="subject" className="mb-1.5 block text-xs font-semibold text-foreground-800">
                意向
              </label>
              <select
                id="subject"
                name="subject"
                className="h-11 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              >
                <option value="订阅追更提醒">订阅追更提醒</option>
                <option value="意见反馈">意见反馈</option>
                <option value="内容合作">内容合作</option>
                <option value="其他">其他</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="mb-1.5 block text-xs font-semibold text-foreground-800">
                留言内容
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                maxLength={500}
                placeholder="告诉我们你想看的新作，或对网站的建议…"
                className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              ></textarea>
              <p className="mt-1 text-right text-xs text-foreground-500">最多 500 字</p>
            </div>

            <div className="mq-honeypot" aria-hidden="true">
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                readOnly
              />
            </div>

            {status === 'error' && (
              <div className="flex items-start gap-2 rounded-lg border border-primary-200 bg-primary-50 px-3 py-2.5 text-sm text-primary-800">
                <i className="ri-error-warning-fill mt-0.5"></i>
                <span>{formError}</span>
              </div>
            )}
            {status === 'success' && (
              <div className="flex items-start gap-2 rounded-lg border border-accent-200 bg-accent-50 px-3 py-2.5 text-sm text-accent-900">
                <i className="ri-checkbox-circle-fill mt-0.5"></i>
                <span>提交成功！我们会尽快处理你的消息，欢迎继续追更～</span>
              </div>
            )}

            <button
              type="submit"
              disabled={status === 'submitting'}
              className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {status === 'submitting' ? (
                <>
                  <i className="ri-loader-4-line mr-2 animate-spin text-base"></i>
                  提交中…
                </>
              ) : (
                <>
                  <i className="ri-mail-send-line mr-2 text-base"></i>
                  提交
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}